import api from '@js/actions/api';

export const fetchCollections = (requestOptions = {}) => (
    api.get('/api/v1/collections', {limit: 100}, {
        priorityLow: true,
        ...requestOptions
    })
);

export const fetchCollection = (id) => (
    api.get(`/api/v1/collections/${id}`)
);

export const fetchRideCollectionIds = (rideId) => (
    api.get(`/api/v1/collections/for-ride/${rideId}`, {}, {priorityLow: true})
);

export const createCollection = (collection) => (
    api.post('/api/v1/collections', {collection})
);

export const updateCollection = (id, collection) => (
    api.update(`/api/v1/collections/${id}`, {collection})
);

export const deleteCollection = (id) => (
    api.delete(`/api/v1/collections/${id}`)
);

export const addRideToCollection = (id, rideId) => (
    api.post(`/api/v1/collections/${id}/add-ride`, {ride_id: rideId})
);

export const removeRideFromCollection = (id, rideId) => (
    api.delete(`/api/v1/collections/${id}/remove-ride`, {ride_id: rideId})
);

export const fetchGroupWishlist = (groupId) => (
    api.get(`/api/v1/collaborative-rides/${groupId}/wishlist`)
);

export const reorderCollection = (id, rideIds) => (
    api.post(`/api/v1/collections/${id}/reorder`, {ride_ids: rideIds})
);
